<template>
  <div class="page_group p_flex p_justify_center p_align_items">
    <div class="not_found">
      <img class="not_found_img" src="../../assets/images/home/404.png" />
      <div class="not_found_txt font_20 color_999999 p_text_center">
        你访问的页面不存在.......<br/>
        <el-link style="color:#DC000C" type="danger" class="font_20">{{ value }}</el-link> 秒后自动跳转首页<br/>
        <el-button type="danger" plain @click="jumpHome">返回主页</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      timer: "",
      value: 3,
    };
  },
  components: {},
  created() {

    this.timer = setInterval(this.computeTime, 1000);
  },
  computed: {},
  methods: {
    computeTime() {
      if (this.value <= 0) {
        this.jumpHome();
        return
      }
      this.value--;
    },
    jumpHome(){
      top.location.href = "/";
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped="scoped">
.page_group {
  height: 100vh;
}

.not_found_img {
  margin: 0 auto;
  display: block;
  width: 3.6rem;
  height: 2rem;
}
.not_found_txt {
  padding-top: 70px;
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/not_found/not_found.vue